export class SelectableItem<T> {
    selected = false;
    value: T;

    public static fromValue<T>(value: T): SelectableItem<T> {
        return {
            value: value,
            selected: false
        };
    }
}